import { Button } from "@volca/ui/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@volca/ui/components/ui/dialog";

interface OptOutConfirmationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  customerName: string;
  isPending: boolean;
  onConfirm: () => void;
}

export const OptOutConfirmationDialog = ({
  open,
  onOpenChange,
  customerName,
  isPending,
  onConfirm,
}: OptOutConfirmationDialogProps) => (
  <Dialog
    open={open}
    onOpenChange={(nextOpen) => {
      if (!nextOpen && isPending) return;
      onOpenChange(nextOpen);
    }}
  >
    <DialogContent showCloseButton={!isPending}>
      <DialogHeader>
        <DialogTitle>Opt {customerName} out of messaging?</DialogTitle>
        <DialogDescription>
          They won't get any more texts from your business.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button
          variant="secondary"
          onClick={() => onOpenChange(false)}
          disabled={isPending}
        >
          Cancel
        </Button>
        <Button
          color="danger"
          onClick={onConfirm}
          disabled={isPending}
          loading={isPending}
        >
          Opt out
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
